import React, { useEffect, useState } from "react";
import Timeline from "../../../component/Timeline/Timeline";
import SectionContainer from "../../../Homepage/SectionContainer";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import banner from "../../../assets/kangaroo/AboutBanner.png"
import MilestoneService from "../../../services/MilestoneService";
import PageService from "../../../services/PageService";
import { useLocation, useParams } from "react-router-dom";
import "../About.css"
import { imageBaseApi } from "../../../services/imageBaseApi";

const AboutMilestone = () => {
  const customData = [
    {
      year: 1990,
      title: "Birth of the Internet",
      description: "The World World Web protocol was created.",
    },
    {
      year: 1998,
      title: "Google Founded",
      description: "The search engine revolution begins.",
    },
    {
      year: 2007,
      title: "Mobile Era",
      description: "First iPhone released, ushering in the smartphone age.",
    },
    {
      year: 2012,
      title: "Cloud Computing Boom",
      description: "Rapid adoption of scalable cloud services.",
    },
    {
      year: 2020,
      title: "Remote Work Shift",
      description: "Global pandemic accelerates digital transformation.",
    },
    {
      year: 2024,
      title: "AI Integration",
      description: "Generative AI tools become mainstream.",
    },
  ];

  const isMobile = window.innerWidth <= 768;

   const location = useLocation();
   const path = location?.pathname?.split("/")?.filter(Boolean).pop();
   console.log(path)


  const [data, setData] = useState([])
  const [detailData, setDetailData] = useState()
  const fetchDetail = async () => {
    try {
      const response = await PageService.getbySlug(path);
      console.log("called", response)
      setDetailData(response)
    } catch (error) {
      console.log(error);

    }
  }
  const fetchData = async () => {
    try {
      const response = await MilestoneService.getList();
      setData(response)
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    fetchData()
  }, [])

  console.log(data)

  useEffect(() => {
    fetchDetail()
  }, [location])
  return (
    <div>
      <div className='about-hero-banner ' style={{ "--banner-img": `url(${imageBaseApi + detailData?.featuredMedia?.url})`, marginBottom: "5.5rem" }}>
        <SectionContainer>
          <BreadCrumb items={[
            { title: "HOME", link: "/" },
            { title: "ABOUT", link: "#" },
            { title: "MILESTONE" },

          ]} instituition={true} />
          <div className=" page-content text-start h-100 d-flex flex-column justify-content-center">
            <h1 className='font-level-4'>MILESTONES</h1>
          </div>
        </SectionContainer>

      </div>
      <div
  className="overflow-hidden" // only needed on parent
  style={{
    width: "100%", // parent is 100%
  }}
>
  <div
    className="d-flex justify-content-center align-items-start "
    style={{
      width: isMobile ? "160%" : "100%", // inner div grows on mobile
    }}
  >
    <Timeline timelineData={data} />
  </div>
</div>

    </div>
  );
};

export default AboutMilestone;
